import logo_iac from "./images/patrocinadores/colaborador/logo_iac.svg"
import logo_arquimea from "./images/patrocinadores/plata/arquimea_positivo.svg"
import logo_mathworks from "./images/patrocinadores/oro/mathworks.svg"
import logo_clustag from "./images/patrocinadores/plata/clustag.svg"
import logo_em3w from "./images/patrocinadores/oro/em3w.svg"
import logo_ull from "./images/logo_ull.svg"
import logo_esit from "./images/patrocinadores/colaborador/escuela-ingenieria-tecnologia-original.svg"
import logo_dpto from "./images/patrocinadores/colaborador/ingenieria-industrial-original.svg"
import logo_datatec from "./images/patrocinadores/oro/logo_datatec.png"
import logo_indra from "./images/patrocinadores/platino/logo-indra.png"
import logo_viavi from "./images/patrocinadores/platino/logo_viavi_oficial.png"
import logo_rs from "./images/patrocinadores/platino/rhode-logo.svg"
import logo_esss from "./images/patrocinadores/platino/esss.png"
import logo_ansys from "./images/patrocinadores/platino/ansys.png"
import logo_principia from "./images/patrocinadores/platino/principia.svg"
import logo_voltera from "./images/patrocinadores/oro/logo_voltera.png"
import logo_uvigo from "./images/patrocinadores/bronce/logo_universidad_vigo.svg"
import logo_oesia from "./images/patrocinadores/bronce/logo_oesia.png"
import logo_coit from "./images/patrocinadores/plata/logo_coit.png"
import logo_imetisa from "./images/patrocinadores/global/IMETISA_reducido.png"
import logo_turismo_lalaguna from "./images/patrocinadores/sponsor/Concejalía de turismo.jpg"
import logo_cultura_lalaguna from "./images/patrocinadores/sponsor/Concejalía de cultura.jpg"
import logo_wirs from "./images/patrocinadores/colaborador/wirs.svg"



// export const patrocinadoresPlatino = [logo_indra, logo_ansys, logo_esss, logo_viavi, logo_datatec, logo_rs, logo_principia]
// export const patrocinadoresOro = [logo_mathworks, logo_nanusens, logo_voltera, logo_keysight, logo_setup, logo_rigol]
// export const patrocinadoresPlata = [logo_tgna, logo_coit, logo_yzaguirre]
// export const patrocinadoresBronce = [logo_oesia]
// export const patrocinadoresSponsor = [logo_ajuntament, logo_turisme, logo_rovira, logo_deeea, logo_palau, logo_etse]

export const patrocinadoresGlobal = [
    [logo_imetisa, 'https://www.imetisa.es/', 1.0]
]
export const patrocinadoresPlatino = [
    [logo_indra, 'https://www.indracompany.com/', 1.3],
    [logo_viavi, 'https://www.viavisolutions.com/', 1.1],
    [logo_rs, 'https://www.rohde-schwarz.com/', 1.5],
    [logo_esss, 'https://www.esss.com/', 1.3],
    [logo_ansys, 'https://www.ansys.com/', 1.1],
    [logo_principia, 'https://www.principia.es/', 1.2],
]
export const patrocinadoresOro = [
    [logo_mathworks, 'https://es.mathworks.com/', 1.3],
    [logo_em3w, 'https://em3works.com/', 1.3],
    [logo_datatec, 'https://www.datatec.es/', 1.1],
    [logo_voltera, 'https://www.voltera.io/', 1.5]
]

export const patrocinadoresPlata = [
    [logo_arquimea, 'https://www.arquimea.com/es/', 1.3],
    [logo_clustag, 'https://clustag.com/', 1.3],
    [logo_coit, 'https://www.coit.es/', 1.3]
]
export const patrocinadoresBronce = [
    [logo_uvigo, 'https://www.uvigo.gal/', 1.3],
    [logo_oesia, 'https://grupooesia.com/', 1.2]
]
export const patrocinadoresSponsor = [
    [logo_turismo_lalaguna, 'https://www.aytolalaguna.es/', 2.75],
    [logo_cultura_lalaguna, 'https://www.aytolalaguna.es/', 1.0]
]
export const patrocinadoresColaborador = [
    [logo_iac, 'https://www.iac.es/', 0.75],
    [logo_ull, 'https://www.ull.es/', 1.3],
    [logo_esit, 'https://www.ull.es/centros/escuela-superior-de-ingenieria-y-tecnologia/', 1.5],
    [logo_dpto, 'https://www.ull.es/departamentos/ingenieria-industrial/', 1.5],
    [logo_wirs, 'https://ursi.es/wirs/', 0.75],
]

export const patrocinadores = patrocinadoresGlobal.concat(patrocinadoresPlatino, patrocinadoresOro, patrocinadoresPlata, patrocinadoresBronce, patrocinadoresSponsor, patrocinadoresColaborador);

// export const patrocinadores = []
